import { AnchorHTMLAttributes, JSX } from 'react';

interface MarkdownLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
}

export default function MarkdownLink(props: MarkdownLinkProps): JSX.Element {
  const { children, ...rest } = props;

  return (
    <a {...rest} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
